import styled from '@emotion/styled';

const Placeholder = styled.div`
  flex: 1 0 0 !important;
  display: flex;
  flex-direction: column;
  background: #fff;
  > h3 {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 24px;
    margin-bottom: 0;
    border-bottom: solid 1px var(--theme-border-1);
  }
`;

export default Placeholder;
